define('Components/Devatics/js/Devatics',['hooks'],function(hooks){
    //
    return function() {
        //
        // hooks.registerHook('openStepCrossSelling',function(params,callback){
        //     // view, validate, ignore
        // });
        // hooks.registerHook('addCrossSellingTab',function(params,callback){
        //     // callback arguments : type, label
        // });
    }

});
